import { type DataForParent, messagesForParent } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
export function callBacksFromCheckoutMicroFrontIframe(data: DataForParent) {
  switch (data.message) {
    case messagesForParent.CANCEL_CONSIGNMENT_SUCCEEDED:
      useAnalyticService().trackEvent('cancel_consignment', { removed_items: data.data })
      break

    default:
      break
  }
}
